import React from "react";
import { useHistory } from "react-router-dom";

export default function WithAuth(WrapperComponent) {
  function Authenticate(props) {
    const history = useHistory();
    const authToken = localStorage.getItem("tspAuthToken");
    const tenantName = localStorage.getItem("currentTenantName");

    const handleRedirect = React.useCallback(() => {
      if (!authToken) {
        if (tenantName) {
          history.push("/auth/login?tenant-name=" + tenantName);
        } else {
          history.push("/auth/login");
        }
      }
    }, [history, tenantName]);

    React.useEffect(() => {
      handleRedirect();
    }, [handleRedirect]);

    return localStorage.getItem("isLoggedIn") === "true" ? (
      <WrapperComponent {...props} />
    ) : (
      ""
    );
  }

  return Authenticate;
}
